const COUNTRY_COLOR_VALUE = "#CFD600";

export type CountryColorDataMap = Record<string, string>;

/**
 * Produces a map of country identifier to color code.
 * @param mapRootElement
 */
export const getColorDataOfCountries = (
  mapRootElement: HTMLElement
): CountryColorDataMap => {
  const countryIdentifierList = mapRootElement.dataset["countries"]?.split(",");

  if (countryIdentifierList === undefined) {
    return {};
  }

  const countryColorData: CountryColorDataMap = {};
  for (const countryIdentifier of countryIdentifierList) {
    countryColorData[countryIdentifier] = COUNTRY_COLOR_VALUE;
  }

  return countryColorData;
};
